/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-03-19 15:55:51
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-03-19 16:05:16
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/SalesChannelPreviewPageComponents//index.tsx
 */
import React from 'react';

import css from './css.less';

const GeneralCollapseWrapper = (props) => {
  const { className, children } = props;
  return (
    <div className={`${css.container} ${className || ''}`}>{children}</div>
  );
};
export default GeneralCollapseWrapper;
